import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Button, Menu } from 'semantic-ui-react';

import LookupSearchTitleEnum from 'PointOfSale/modules/lookup/component/LookupSearchTitleEnum';
import { SessionTypes } from 'PointOfSale/modules/common/constants';

import POSKeyboardInput from 'PointOfSale/modules/common/component/KeyboardInput';

const LookUpMenu = ({
  onSearchChange,
  searchTerm,
  showLoading,
  visitingStudents,
  toggleVisitingStudentStatus,
  activeSession,
  onLookUpInputFocus,
  onLookUpInputBlur,
  onLookupClose,
}) => (
  <Menu secondary>
    <Menu.Item className="flex-1">
      <POSKeyboardInput
        placeholder={LookupSearchTitleEnum[activeSession]}
        className="lookup-search"
        onChange={onSearchChange}
        value={searchTerm}
        iconPosition="left"
        icon="search"
        loading={showLoading}
        focusOnMount
        onFocus={onLookUpInputFocus}
        onBlur={onLookUpInputBlur}
      />
    </Menu.Item>
    <Menu.Item>
      {activeSession !== SessionTypes.Teacher && (
        <Checkbox
          slider
          label="Visiting students"
          checked={visitingStudents}
          onClick={toggleVisitingStudentStatus}
        />
      )}
    </Menu.Item>
    <Menu.Item>
      <Button
        onClick={() => onLookupClose()}
        icon={'close'}
        className="lookup-close"
        color={'orange'}
        size={'large'}
      />
    </Menu.Item>
  </Menu>
);

LookUpMenu.propTypes = {
  onLookupClose: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func,
  searchTerm: PropTypes.string,
  showLoading: PropTypes.bool,
  activeSession: PropTypes.string,
};

export default LookUpMenu;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/lookup/component/LookUpMenu.js